import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginUserDatas: [],
    perfectUserMsg: {}
  },
  mutations: {
    loginUserData(state, data) {
      state.loginUserDatas = data
    },
    changePwd(state, pwd) {
      state.c1password = pwd
    },
    perfectUserMsgs(state, data) {
      state.perfectUserMsg = data
    }
  },
  actions: {},
  getters: {
    getLoginUserData(state) {
      return state.loginUserDatas
    },
    getPerfectUserMsgs(state) {
      return state.perfectUserMsg
    }
  }
})